












import { Component, Vue } from 'vue-property-decorator';
import { clientsModule, authModule, shoppingModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';

@Component({
  name: 'navbar-bar',
  components: { UserMenu, MainNavbar },
})
export default class RightBar extends Vue {
  get client() {
    return clientsModule.model;
  }

  get user() {
    return authModule.whoIam;
  }

  get shopping() {
    if (this.$route.params.shoppingId) {
      return shoppingModule.current;
    }
    return null;
  }

  logout() {
    authModule.logout()
      .then(() => {
        this.$router.push({ name: 'login' });
      })
      .catch((e) => {
        this.$message.error(e);
      });
  }
}
